<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Collapse</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Basic Example</h5>
              <p>Click the buttons below to show and hide another element via class changes:</p>
              <ul>
                <li><code class="text-danger">.collapse</code> hides content</li>
                <li><code class="text-danger">.collapsing</code> is applied during transitions</li>
                <li><code class="text-danger">.collapse.show</code> shows content</li>
              </ul>
              <p>You can use a link with the <code class="text-danger">href</code> attribute, or a button with the <code
                  class="text-danger">data-target</code> attribute. In both cases, the <code
                  class="text-danger">data-bs-toggle="collapse"</code> is required.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <p>
                    <a class="btn btn-primary" data-bs-toggle="collapse" href="javascript:void(0);"
                      (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
                      aria-controls="collapseBasic">
                      Link with href
                    </a>
                    <button class="btn btn-primary ml-1" type="button" (click)="isCollapsed = !isCollapsed"
                      [attr.aria-expanded]="!isCollapsed" aria-controls="collapseBasic">
                      Button with data-target
                    </button>
                  </p>
                  <div class="collapse" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true">
                    <div class="card card-body">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
                      Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;p&gt;
      &lt;a class=&quot;btn btn-primary&quot; data-toggle=&quot;collapse&quot; href=&quot;#collapseExample&quot; role=&quot;button&quot; aria-expanded=&quot;false&quot; aria-controls=&quot;collapseExample&quot;&gt;
        Link with href
      &lt;/a&gt;
      &lt;button class=&quot;btn btn-primary&quot; type=&quot;button&quot; data-toggle=&quot;collapse&quot; data-target=&quot;#collapseExample&quot; aria-expanded=&quot;false&quot; aria-controls=&quot;collapseExample&quot;&gt;
        Button with data-target
      &lt;/button&gt;
    &lt;/p&gt;
    &lt;div class=&quot;collapse&quot; id=&quot;collapseExample&quot;&gt;
      &lt;div class=&quot;card card-body&quot;&gt;
        Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
      &lt;/div&gt;
    &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Multiple targets</h5>
              <p>A <code class="text-danger">&lt;button&gt;</code> or <code class="text-danger">&lt;a&gt;</code> can
                show
                and hide multiple elements by referencing them with a JQuery selector in its <code
                  class="text-danger">href</code> or <code class="text-danger">data-target</code> attribute.
                Multiple <code class="text-danger">&lt;button&gt;</code> or <code class="text-danger">&lt;a&gt;</code>
                can
                show and hide an element if they each reference it with their <code class="text-danger">href</code> or
                <code class="text-danger">data-target</code> attribute
              </p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <p>
                    <a class="btn btn-primary" href="javascript:void(0);" (click)="isCollapsed1 = !isCollapsed1"
                      [attr.aria-expanded]="!isCollapsed1" aria-controls="collapseBasic">Toggle first element</a>
                    <button class="btn btn-primary ml-1" (click)="isCollapsed2 = !isCollapsed2"
                      [attr.aria-expanded]="!isCollapsed2" aria-controls="collapseBasic">Toggle second element</button>
                    <button class="btn btn-primary ml-1" type="button" (click)="isCollapsed3 = !isCollapsed3"
                      [attr.aria-expanded]="!isCollapsed3" aria-controls="collapseBasic">Toggle both elements</button>
                  </p>
                  <div class="row">
                    <div class="col">
                      <div class="collapse multi-collapse" id="collapseBasic" [collapse]="isCollapsed1"
                        [isAnimated]="true">
                        <div class="card card-body">
                          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad
                          squid.
                          Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea
                          proident.
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="collapse multi-collapse" id="collapseBasic" [collapse]="isCollapsed2"
                        [isAnimated]="true">
                        <div class="card card-body">
                          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad
                          squid.
                          Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea
                          proident.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="collapse multi-collapse" id="collapseBasic" [collapse]="isCollapsed3"
                        [isAnimated]="true">
                        <div class="card card-body">
                          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad
                          squid.
                          Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea
                          proident.
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="collapse multi-collapse" id="collapseBasic" [collapse]="isCollapsed3"
                        [isAnimated]="true">
                        <div class="card card-body">
                          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad
                          squid.
                          Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea
                          proident.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;p&gt;
      &lt;a class=&quot;btn btn-primary&quot; data-toggle=&quot;collapse&quot; href=&quot;#multiCollapseExample1&quot; role=&quot;button&quot; aria-expanded=&quot;false&quot; aria-controls=&quot;multiCollapseExample1&quot;&gt;Toggle first element&lt;/a&gt;
      &lt;button class=&quot;btn btn-primary&quot; type=&quot;button&quot; data-toggle=&quot;collapse&quot; data-target=&quot;#multiCollapseExample2&quot; aria-expanded=&quot;false&quot; aria-controls=&quot;multiCollapseExample2&quot;&gt;Toggle second element&lt;/button&gt;
      &lt;button class=&quot;btn btn-primary&quot; type=&quot;button&quot; data-toggle=&quot;collapse&quot; data-target=&quot;.multi-collapse&quot; aria-expanded=&quot;false&quot; aria-controls=&quot;multiCollapseExample1 multiCollapseExample2&quot;&gt;Toggle both elements&lt;/button&gt;
  &lt;/p&gt;
  &lt;div class=&quot;row&quot;&gt;
      &lt;div class=&quot;col&quot;&gt;
          &lt;div class=&quot;collapse multi-collapse&quot; id=&quot;multiCollapseExample1&quot;&gt;
              &lt;div class=&quot;card card-body&quot;&gt;
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
              &lt;/div&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;col&quot;&gt;
          &lt;div class=&quot;collapse multi-collapse&quot; id=&quot;multiCollapseExample2&quot;&gt;
              &lt;div class=&quot;card card-body&quot;&gt;
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident.
              &lt;/div&gt;
          &lt;/div&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

            <div class="col-lg-12">
              <h5 class="card-title mb-1">Accordion example</h5>
              <p>Using the <a href="https://getbootstrap.com/docs/4.5/components/card/">card</a> component, you can
                extend
                the default collapse behavior to create an accordion. To properly achieve the accordion style, be sure
                to
                use <code class="text-danger">.accordion</code> as a wrapper.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <accordion [isAnimated]="true">
                    <accordion-group heading=" Collapsible Group Item #1">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad
                      squid.
                      3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt
                      laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin
                      coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes
                      anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
                      occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't
                      heard
                      of them accusamus labore sustainable VHS.
                    </accordion-group>
                    <accordion-group heading=" Collapsible Group Item #2">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad
                      squid.
                      3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt
                      laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin
                      coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes
                      anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
                      occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't
                      heard
                      of them accusamus labore sustainable VHS.
                    </accordion-group>
                    <accordion-group heading=" Collapsible Group Item #3">
                      Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad
                      squid.
                      3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt
                      laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin
                      coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes
                      anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings
                      occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't
                      heard
                      of them accusamus labore sustainable VHS.
                    </accordion-group>
                  </accordion>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;div class=&quot;accordion&quot; id=&quot;accordionExample&quot;&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;div class=&quot;card-header&quot; id=&quot;headingOne&quot;&gt;
              &lt;h2 class=&quot;mb-0&quot;&gt;
              &lt;button class=&quot;btn btn-link btn-block text-start&quot; type=&quot;button&quot; data-toggle=&quot;collapse&quot; data-target=&quot;#collapseOne&quot; aria-expanded=&quot;true&quot; aria-controls=&quot;collapseOne&quot;&gt;
                  Collapsible Group Item #1
              &lt;/button&gt;
              &lt;/h2&gt;
          &lt;/div&gt;

          &lt;div id=&quot;collapseOne&quot; class=&quot;collapse show&quot; aria-labelledby=&quot;headingOne&quot; data-parent=&quot;#accordionExample&quot;&gt;
              &lt;div class=&quot;card-body&quot;&gt;
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              &lt;/div&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;div class=&quot;card-header&quot; id=&quot;headingTwo&quot;&gt;
              &lt;h2 class=&quot;mb-0&quot;&gt;
              &lt;button class=&quot;btn btn-link btn-block text-start collapsed&quot; type=&quot;button&quot; data-toggle=&quot;collapse&quot; data-target=&quot;#collapseTwo&quot; aria-expanded=&quot;false&quot; aria-controls=&quot;collapseTwo&quot;&gt;
                  Collapsible Group Item #2
              &lt;/button&gt;
              &lt;/h2&gt;
          &lt;/div&gt;
          &lt;div id=&quot;collapseTwo&quot; class=&quot;collapse&quot; aria-labelledby=&quot;headingTwo&quot; data-parent=&quot;#accordionExample&quot;&gt;
              &lt;div class=&quot;card-body&quot;&gt;
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              &lt;/div&gt;
          &lt;/div&gt;
      &lt;/div&gt;
      &lt;div class=&quot;card&quot;&gt;
          &lt;div class=&quot;card-header&quot; id=&quot;headingThree&quot;&gt;
              &lt;h2 class=&quot;mb-0&quot;&gt;
              &lt;button class=&quot;btn btn-link btn-block text-start collapsed&quot; type=&quot;button&quot; data-toggle=&quot;collapse&quot; data-target=&quot;#collapseThree&quot; aria-expanded=&quot;false&quot; aria-controls=&quot;collapseThree&quot;&gt;
                  Collapsible Group Item #3
              &lt;/button&gt;
              &lt;/h2&gt;
          &lt;/div&gt;
          &lt;div id=&quot;collapseThree&quot; class=&quot;collapse&quot; aria-labelledby=&quot;headingThree&quot; data-parent=&quot;#accordionExample&quot;&gt;
              &lt;div class=&quot;card-body&quot;&gt;
              Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
              &lt;/div&gt;
          &lt;/div&gt;
      &lt;/div&gt;
  &lt;/div&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
